/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <CallToAction {...cmsData} />)
 * and then make these props fit the final module.
 */
import React from "react"
import { Section } from "@bw/bits"
import { CallToAction as CallToActionModule } from "@bw/modules"
import { graphql } from "gatsby"

const CallToAction = ({
  linkText,
  linkType,
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  backgroundVariant,
  entry,
  url,
}) => {
  return (
    <Section
      {...{ button, buttonPosition, backgroundVariant }}
      containerSize="large"
    >
      <CallToActionModule
        {...{ suptitle, title, subtitle }}
        buttonLabel={linkText}
        href={linkType.value === "url" ? url : null}
        to={linkType.value === "entry" && entry ? entry.url : null}
      />
    </Section>
  )
}

export const query = graphql`
  fragment CallToActionModuleFragment on CallToActionModule {
    linkText
    linkType {
      value
    }
    url
    entry {
      url
    }
  }
`

export { CallToAction }
